// The fixed identity of the synthetic verification organisation. It is provisioned and
// torn down around every scheduled verification run by the internal-ops synthetic-org
// endpoints; apps/verification-tests/e2e mirrors the email as a literal (standalone
// package, cannot import from here), so any change must be applied in both places.
export const SYNTHETIC_ORG_ID = 'f7268ab2-c754-451b-b59a-16214173980a'
export const SYNTHETIC_USER_ID = '53276356-0930-4074-847b-2531732657f7'
export const SYNTHETIC_ORG_NAME = 'Synthetic Verification'
export const SYNTHETIC_ORG_DOMAIN = 'synthetic.omnea.co'
export const SYNTHETIC_USER_EMAIL = `sindy.synthetic@${SYNTHETIC_ORG_DOMAIN}`
export const SYNTHETIC_USER_FIRST_NAME = 'Sindy'
export const SYNTHETIC_USER_LAST_NAME = 'Synthetic'
export const SYNTHETIC_WORKFLOW_NAME = '[TEST WORKFLOW] Basic form validation'
// The intake-and-approval journey: an intake (file upload + conditionality) feeding an
// approval the synthetic user approves in-app. apps/verification-tests/e2e matches this
// name on the /start page as a literal, so any change must be applied in both places.
export const SYNTHETIC_INTAKE_APPROVAL_WORKFLOW_NAME = '[TEST WORKFLOW] Intake and approval'
// The mobile journey: a simple intake feeding an approval the mobile user actions in-app on a
// mobile viewport, so the mobile-only components (request cards, table search, form-viewer back
// button) render against the user's own request. apps/verification-tests/e2e matches this name
// on the /start page as a literal, so any change must be applied in both places.
export const SYNTHETIC_MOBILE_WORKFLOW_NAME = '[TEST WORKFLOW] Mobile intake and approval'

export type SyntheticJourneyUser = { id: string; email: string; firstName: string; lastName: string }

// Each browser journey authenticates as its own user, so journeys (and overlapping runs of
// the suite) never share a login or task inbox. /auth/signup provisions the auth user at test
// time; the seed creates the DB user that login and the approval assignee resolve to.
// apps/verification-tests/e2e mirrors these emails as literals, so keep them in sync.
export const SYNTHETIC_JOURNEY_USERS = {
  intakeApproval: {
    id: '1e6a9c74-3b2d-4f81-9a05-7c8e2d1b4f60',
    email: `intake-approval@${SYNTHETIC_ORG_DOMAIN}`,
    firstName: 'Intake',
    lastName: 'Approver',
  },
  mobile: {
    id: '2f7b8c05-4c3e-4a92-b016-8d9f3e2c5a71',
    email: `mobile@${SYNTHETIC_ORG_DOMAIN}`,
    firstName: 'Mobile',
    lastName: 'Journey',
  },
} satisfies Record<string, SyntheticJourneyUser>
